import styled from 'styled-components';

export const StyledDescription = styled.div`
font-size: 15px !important;
font-weight: bold;
margin: 15px 0px;
`

export const StyledSegmentWrapper = styled.div`
  margin: 2em 0em;
 .header {
  width: auto !important;
  margin: 0px !important;
  border-top-right-radius: 1em !important;
  border-top-left-radius: 1em !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  .title {
    max-width: 70% !important;
    white-space: break-spaces !important; 
    font-size: 15px !important;
  }
 }

 .segment {
  margin-left: 0 !important;
  min-height: 150px !important;
  width: auto !important;
  margin-right: 0 !important;
  border-bottom-right-radius: 1em !important;
  border-bottom-left-radius: 1em !important;  
  display: flex;
  flex-wrap: wrap;
 }
 
 .disabled {
  opacity: 1 !important;
  >label {
    opacity: 1 !important;
  }
 }
}
`
export const StyledWrapper = styled.div`
.message {
  margin-top: 20px;
  text-align: center;
  border-radius: 10px;
}
`
export const StyledAnswer = styled.div`
  font-size: 15px !important;
  margin-bottom: 5px;
  border: 1px solid #e5e7eb;
  padding: 7px;
  border-radius: 5px;    
  color: #4183c4;
  margin-left: 10px;
`